/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_BackInputs */

const en_session_back = /** @type {(inputs: Session_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to recipes`)
};

const de_session_back = /** @type {(inputs: Session_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Rezepten`)
};

/**
* | output |
* | --- |
* | "Back to recipes" |
*
* @param {Session_BackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_back = /** @type {((inputs?: Session_BackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_BackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_back(inputs)
	return en_session_back(inputs)
});